<template>
  <div>
    <a href="http://www.nih.gov/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/NIH.svg"
        alt="NIH"
        title="NIH"
        class="nih" />
      <img v-else src="./img/NIH-darkMode.svg" alt="NIH" title="NIH" class="nih" />
    </a>
    <a href="http://www.broadinstitute.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Broad.png"
        alt="Broad Institute"
        title="Broad Institute" />
      <img v-else src="./img/Broad-darkMode.png" alt="Broad Institute" title="Broad Institute" />
    </a>
    <a href="http://www.nvidia.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/nvidia.svg" alt="NVIDIA" title="NVIDIA" />
      <img v-else src="./img/NVIDIA-darkMode.svg" alt="NVIDIA" title="NVIDIA" />
    </a>
    <a href="http://www.autodesk.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Autodesk.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
      <img
        v-else
        src="./img/Autodesk-darkMode.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
    </a>
    <a href="http://ami.org/" rel="nofollow">
      <img src="./img/AMI.png" alt="AMI" title="AMI" />
    </a>
    <a href="http://alleninstitutecellscience.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/AllenInstitute.png"
        alt="Allen Institute"
        title="Allen Institute" />
      <img v-else src="./img/AllenInstitute-darkMode.png" alt="Allen Institute" title="Allen Institute" />
    </a>
    <a href="http://www.nature.com/nprot/" rel="nofollow">
      <img src="./img/Nature_Protocols.png" alt="Nature Protocols" title="Nature Protocols" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <h4 id="why">About VIZBI Sponsorship</h4>
  <p>
    VIZBI is an international conference series on Visualizing Biological Data, funded by the NIH
    and EMBO. It alternates annually between the European Molecular Biology Laboratory in
    Heidelberg, Germany, and the Broad Institute of MIT and Harvard in Cambridge MA, USA.
  </p>
  <p>
    VIZBI 2015 offered opportunities to promote organisations engaged with either data
    visualisation or the life sciences. Over 130 scientists, software developers, medical
    professionals, illustrators and designers from around the world attended, along with a further
    30 delegates via live stream.
  </p>
  <p>
    If you are interested in future sponsorship opportunities, please download the
    <a href="/2015/Sponsorship_form.pdf" target="_blank">VIZBI sponsorship options</a>
    or contact us at <Email to="vizbi-contact" />.
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.nih {
  max-height: calc(3.3rem * 1.4);
}
img.autodesk {
  max-height: calc(3.3rem * 0.6);
}
</style>
